import { GetContactRecordsParams } from "./../types/types";
import { useQuery } from "@tanstack/react-query";
import { getContactRecords } from "../api/admin";

const useGetContactRecords = ({
  startDate,
  endDate,
  searchKey,
  area,
  page,
  fetch,
  admin_idx,
  sort,
  limit,
}: GetContactRecordsParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      "contactRecords",
      `startDate-${startDate}`,
      `endDate-${endDate}`,
      `searchKey-${searchKey}`,
      `area-${area}`,
      `page-${page}`,
      `admin_idx-${admin_idx}`,
      `sort-${sort}`,
    ],
    queryFn: () =>
      getContactRecords({
        startDate,
        endDate,
        searchKey,
        area,
        page,
        admin_idx,
        sort,
        limit,
      }),

    retry: false,
    enabled: fetch,
    refetchOnWindowFocus: false,
    staleTime: 0,
  });

  return { data, isLoading, isSuccess };
};

export default useGetContactRecords;
